import React, { Component } from 'react';
import Header from '../../../Layout/Header'
import Sidebar from '../Sidebar'
import { Route } from 'react-router-dom';


class BlogItem extends Component {
	render() {
		return (
			<div>
				<Header
					bg="none"
					image={require('./image.jpg')}
					title={"Understand Your Marketing Data"}
				/>
				<div className="entry-content">
					
					<div className="container">
						<h2 className="blog-details">
								<div className="author-circle david"></div>
								<div className="line"></div>
								<div className="title">
									Written by <strong>David</strong> on Sep 14 2020  //  Posted in <strong>Marketing</strong>
								</div>
						</h2>
						
						<div className="row">
							<div className="col-lg-7">
								<div className="tagline">
									What does your marketing data say?
								</div>
								
								<p>Since we’ve been coming together, data has been important. Archaeological records show notches
									on sticks or stones to record trading supplies
									over
									18,000 years
									ago.
									The use of statistical models to
									collect data
									pops up
									in Ancient Greece, with soldiers report
									ing
									back how many bricks high defensive
									walls were
									and
									the mode (most common figure) used to create ladders to scale them.
									But it wasn’t
									until
									the 17th
									century
									that data collection
									/
									analysis or ‘statistics’ came into
									its own,
									when a
									London
									draper
									took an interest in public health, spent
									years trawling through
									local Parish records
									and
									then
									was
									able to estimate the population of London and England, birth and mortality rates, and the rise
									and spread of some diseases.
									</p>
									<p>
									Two
									hundred years later, the term ‘business intelligence’
									was
									created
									when one of the original directors of the Bank of England
									used data
									to get a better understanding
									over his competitors
									of market conditions, gaining an advantage by acting before they did.
									However, he used this newfound power for immoral purposes,
									a
									practice that unfortunately
									continues
									today.
									A
									few decades later
									,
									a young engineer invented punch cards to store data
									, reducing
									10 years of his work into 3 months (hope he got a raise!),
									and
									the
									rest is history.</p>

									<p>
									Until recently,
									data
									remained
									the domain of big business. Methods to collect data were
									difficult
									and
									expensive, while machines to store data were even more so. It wasn’t until the invention of the
									home computer and the
									internet that data for small business became
									affordable
									and easily
									accessible, and
									only in the last decade has online consumer behaviour grown to the point where this
									can
									serve as a reasonable guide
									for
									business decisions.
									The use of data is so new that
									most
									small
									businesses lack the knowledge or confidence to use
									what is available to them
									, while at the same
									time
									big businesses
									stake their life
									on it.
									What is more,
									small
									businesses don’t need
									to use the
									vast
									resources big businesses
									use
									on
									the
									collection and
									analysis
									of data
									-
									with the digital tools
									readily
									available today
									, all they need is a little bit of awareness.
									</p><br/>

									<h4>Key Data Metrics For Busines</h4>

									<strong>1. WHO IS YOUR CUSTOMER?</strong>
									<p>
										From website analytics and social media data,
										there is a huge amount of data on people who
										take an
										interest in your business.
										If you know where to look, you can find data on your audience’s
										age,
										gender, location and language, to interests both short and long term.
										Even though we all think we
										have a pretty good idea who are customers are, there can be a sharp distinction between decision
										maker, shopper and user
										. The husband may come in-store to make the final purchase
										, but it was the
										wife online the night before who called the shots.
										These results can have significant impact on
										your
										business; we have rebranded
										companies
										more than once based on the analysis of their traffic data.
									</p><br/>

									<strong>2. HOW DO THEY SHOP?</strong>
									<p>
									Gone are the days when your customer followed linear paths to purchase
(
ie: looked up the Yellow
Pages, found your number, called and came in to
buy).
Today,
your
customer’s
paths
are numerous
and complex.
When mapped out,
they quickly start to look like strands of intertwined spaghetti, as
customers skip from one digital platform to another, come and go in stores to browse, and finally
purchase in person,
online or by phone depending on preferences or
circumstances.
Even though a
clear picture of this is
near
impossible, website and social media data will give you a fair idea of the
types of behaviour your customer has. You can even monitor website traffic
in real time to see if TV
or radio adverts have an impact.
									</p>

									<p>
									What’s more, when using digital advertising
(
particularly those
methods
based on
people’s
search
terms
),
you can develop a picture of how interested
your audience is,
and
what levels of demand
there are for your goods
and services.
This data can even reveal exactly how many searches there
are for your products
-
invaluable information when planning your business over the year!
									</p><br/>

									<strong>3. HOW IS YOUR COMPETITION?</strong>
									<p>
										There is the saying
that you shouldn’t worry about what your competition is doing.
However,
it
doesn’t hurt to keep an eye on them every now and then.
Both social media and Google Search
platforms provide performance information of your closest competitors, allowing you to gauge your
marketing against them.
</p>
<p>
Knowing what your competitors are doing in the digital space has far
reaching impact, for instance, at the beginning of COVID-19 it was clear from the data that many
competitors
were withdrawing their digital budgets in the
face of uncertainty.
This caused
the cost
of digital advertising
to
drop 20-30%,
so we recommended our clients increase their budgets to take
advantage of the vacuum.
When circumstances returned to some normalcy, these businesses were
in a strong, dominant digital position which they have been able to retain since.
</p><br/>

									<strong>4. BUT WHAT MARKETING STRATEGIES ARE WORKING BEST?</strong>
									<p>
									The million dollar question - where should I put my marketing dollar?
									</p>
									<p>
									This is still a very difficult question, but we are a lot closer to the
									answer now than we were before.
									The other big question I get asked is, “can you guarantee results?”
									I really wish I could, but when
									investment bankers with floors of data analysts have trouble working out what will happen
									tomorrow, it’s fair to say that we will
									be in the same boat
									as well. What we can guarantee is a great
									data set to find patterns that will
									provide
									insight into future behaviour to make
									informed
									business
									decisions.
									</p>
									<p>
									This, in combination with what is happening on the business’ ‘floor’, will provide a picture
									of what is working and what is not.
									You
									could keep pouring resources into data analysis to try and
									work out the exact marketing return, but you quickly hit a point of diminishing return, where time is
									better spent working on the business than crunching numbers. After all, data analysis does not
									create
									direct
									sales.
									</p><br/>

									<strong>5. LET THE MACHINE RUN IT FOR YOU</strong>
									<p>
									The most exciting thing about modern data analysis is machine learning. If all the above was not
available,
it is still worthwhile
setting up
accurate data sets to take advantage of its enormous
power
									</p>

									<p>
									We are in the infant stages of machine learning,
and already companies like Google have created
systems so advanced they can easily beat the world’s best players in games like chess or ‘Go’
-
a
game with nearly an infinite amount of moves, more than there are atoms in the universe (chess
only has a trivial 10 followed by 123 zeros moves).
									</p>

									<p>
									The use of machine learning is continually evolving,
with recent news of jet fighters using AI machine
learning having a 100% win rate against human pilots
-
to have this power behind your marketing is
the
highest
bar. Google’s advertising platform
(
given its dynamic advert format and 40+ indicators
measuring user behaviour
), provides a sample space over 50 digits long. This is way beyond the

ability of any human
(
or team of humans
!), to analysis and meaningfully use. Machine learning does
this all for you. Over time, through analysis of data, the system learns what type of advert
will give
the best chance of creating a sale,
including which format, what time of day, and on which platform.
									</p>

									<p>
									Over time, it will figure out what your customers will do before they need you,
and start targeting
them at this stage of the purchasing cycle.
The longer machine learning is left analysing data, the
better the system gets and the more efficient your marketing becomes. Machine learning can’t do
everything <i>yet</i> (thankfully
!) but it is the future of marketing,
and companies not using it will be
left behind.
									</p><br/>

									<strong>6. ONLY AS GOOD AS THE QUALITY OF YOUR DATA</strong>
									<p>When push comes to shove, data is only as good as the means
by which
you collect it. Take the
example of the
19th
century
London draper.
Whilst
doing his research he
was critical of
the‘
Collectors’,
who determined the cause of death, as they incorrectly ascribed many to the plague
inflating actual numbers</p>

						<p>
						Today with
the introduction of machine learning, the need for accuracy is even more crucial.
Machine learning has a dark side, so while it gets more accurate over time with good data, bad data
will create errors that will worsen over time.
It is not unrealistic to see a future where businesses will
not succeed
due
to
the failure of their machine learning platforms.
By the time
these businesses
work out they are being sent down the wrong path, it will be too late
to turn back.
						</p>

						<p>
						In conclusion, one of the most important
things a business can do is create an accurate, meaningful
data set. The other important thing is to use this data and stay on top of it, analyse it, and make plans
that can be measured with it.
						</p>

							<p>- Make sure you set up your website properly from the get-go, so as much information can be gleaned as possible</p>
							<p>- Stay aware of your social media data to see who is interested and what they are interested in</p>
							<p>- Keep an eye on your competitors so you can respond immediately to their changes</p>
							<p>- And use one of the most powerful technological inventions ever made... machine learning, to help build your business</p>

						<p>
							None of the above is easy, so if you are in any doubt, talk to a specialist who can take care of this
							crucial part of your business and you can focus on what your
							should be doing
							-
							helping your
							customer.
						</p>
							</div>
							<div className="col-lg-1"></div>
							<div className="col-lg-4">
								<Sidebar />
							</div>
						</div>
					</div>
				</div>

			</div>
		);
	}
}

export default BlogItem;


// WEBPACK FOOTER //
// ./src/Pages/Blog/UnderstandYourMarketingData/index.js